import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #002244;
  gap: 4px;
  margin: 90px 0px;
`;

export const HighlightText = styled.p`
  margin-bottom: 0px;
  font-size: 18px;
  line-height: 22px;
  font-weight: 600;
`;

export const Text = styled.p`
  margin-bottom: 0px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
`;

export const customStyles = {
  headRow: {
    style: {
      backgroundColor: "#f6f6f6",
    },
  },
  headCells: {
    style: {
      color: "#533d59",
      fontSize: "14px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      textAlign: "left",
    },
  },
  rows: {
    style: {
      color: "#002244",
      fontSize: "14px",
      fontWeight: "400",
      fontFamily: "Inter",
      backgroundColor: "#fff",
      "&:hover": {
        backgroundColor: "rgba(17, 167, 217, 0.03)",
      },
    },
  },
};

export const TableContainer = styled.div`
  width: 100%;
  background-color: #fff;
  .rdt_Table {
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
  }

  .rdt_Pagination {
    border: 0;
  }
`;
